import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import {
    API_IS_BEING_CANCELLED,
    DROPDOWN_SIZES,
    ENDPOINTS,
    TASK_TYPES,
    useApi,
    useIsMounted
} from "../../../../../../../../shared";
import Autocomplete from "../../../../../../../DesignComponents/Autocomplete";
import { renderCanAdapterType } from "../../functions";
import { AdapterTypesProps, AdapterValue, CanAdapterType } from "./types";

const AdapterTypes = ({
    taskType,
    isSubmitLoading,
    value,
    changeType
}: AdapterTypesProps) => {
    const { t } = useTranslation();
    const { getData, handleResponse, cancelSource, isCanceled } = useApi();
    const isMounted = useIsMounted();

    const [isLoading, setIsLoading] = useState(false);
    const [adapters, setAdapters] = useState([]);

    useEffect(() => {
        const getAdapterTypes = async () => {
            try {
                setIsLoading(true);

                const { data } = await getData(ENDPOINTS.CanAdapterTypes);

                if (isMounted) {
                    const internalType =
                        taskType === TASK_TYPES.TxCanAdapterModeChange ? 0 : 1;

                    const filteredAdapters = data.filter(
                        (adapter: CanAdapterType) =>
                            adapter.internal === internalType
                    );

                    setAdapters(filteredAdapters);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                }
            }

            setIsLoading(false);
        };

        getAdapterTypes();

        return () => {
            cancelSource.cancel(API_IS_BEING_CANCELLED);
        };

        // eslint-disable-next-line
    }, [taskType]);

    const handleChange = (adapterInfo: AdapterValue) => changeType(adapterInfo);

    return (
        <Autocomplete
            fullWidth
            isRequired
            size={DROPDOWN_SIZES.Medium}
            labelLeft={t("Dialog##can adapter")}
            value={value}
            getOptionLabel={option => renderCanAdapterType(option)}
            textFieldParams={{
                placeholder: t("Dialog##select")
            }}
            loading={isLoading}
            options={adapters}
            readOnly={isSubmitLoading}
            onChange={(_, value) => handleChange(value)}
        />
    );
};

export default AdapterTypes;
